import { render, staticRenderFns } from "./NotificacaoAcoes.vue?vue&type=template&id=63448c6f&scoped=true&"
import script from "./NotificacaoAcoes.vue?vue&type=script&lang=js&"
export * from "./NotificacaoAcoes.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoAcoes.vue?vue&type=style&index=0&id=63448c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63448c6f",
  null
  
)

export default component.exports